//
//
//
//
//
//
//

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ["value"],
  name: 'numRange',
  data: function data() {
    return {
      min: undefined,
      max: undefined
    };
  },
  watch: {
    value: function value(val) {
      if (Array.isArray(val) && val.length === 2) {
        this.min = val[0];
        this.max = val[1];
      } else {
        this.min = undefined;
        this.max = undefined;
      }
    }
  },
  methods: {
    onChange: function onChange() {
      if (!this.min && this.min !== 0 && !this.max && this.max !== 0) return this.$emit('change', []);
      this.$emit('change', [this.min, this.max]);
    }
  }
};